<template>
  <div
    class="audio-hero">
    <div class="audio-hero__container container">
      <div class="grid">
        <audio-hero-content
          :headline-variation="headlineVariation"
          class="audio-hero__content" />
        <audio-hero-image class="audio-hero__image" />
      </div>
    </div>
  </div>
</template>

<script>
import AudioHeroContent from "./audio-hero-content.vue";
import AudioHeroImage from "./audio-hero-image.vue";

export default {
  name: "AudioHero",
  components: {
    AudioHeroContent,
    AudioHeroImage
  },
  props: {
    headlineVariation: {
      type: String,
      default: "headlineA"
    }
  }
};
</script>

<style lang="scss" scoped>
.audio-hero {
  overflow: hidden;

  &__container {
    padding: 0;

    @include media(min-width, m) {
      @include container;
    }
  }

  &__content {
    grid-area: 1 / 1 / 1 / 13;

    @include media(min-width, m) {
      margin-bottom: 0;
      padding: 0;
      grid-template-columns: repeat(12, 1fr);
      grid-auto-rows: minmax(min-content, max-content);
      grid-area: 1 / 1  / 1 / 8;
    }
    @include media(min-width, l) {
      padding: 0;
      grid-template-columns: repeat(12, 1fr);
      grid-auto-rows: minmax(min-content, max-content);
      grid-area: 1 / 1  / 1 / 9;
    }
  }

  &__image {
    /* stylelint-disable-next-line unit-blacklist */
    margin-bottom: spacing(45px);

    grid-area: 2/ 1 / 2/ 13;

    @include media(min-width, m) {
      grid-area: 1 / 4 / 1 / 13;
    }
    @include media(min-width, l) {
      grid-area: 1 / 4 / 1 / 13;
    }
  }
}
</style>
